import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { FormErrorMessage, FormItem } from "@/components/ui/form/_base/form";
import { DatePickerRange } from "@/components/ui/input/date-picker-range";

import { useCinTerm } from "./hooks";

export const QuestionCinTerm = () => {
	const { cinStart, cinEnd, onSetCinTerm } = useCinTerm();

	const title = "宿泊（チェックイン）が可能な期間";
	const guide = "";
	const errorMessage = cinStart?.error || cinEnd?.error;

	return (
		<QuestionForMain
			required={true}
			title={title}
			guide={guide}
			inputChildren={
				<FormItem>
					<DatePickerRange
						selected={{
							from: cinStart?.value ?? undefined,
							to: cinEnd?.value ?? undefined,
						}}
						onSelect={onSetCinTerm}
					/>
					<FormErrorMessage>{errorMessage}</FormErrorMessage>
				</FormItem>
			}
		/>
	);
};

QuestionCinTerm.displayName = "QuestionCinTerm";
